import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { useCurrentSiteId } from '@hotjar/site';
import { getActivityFeed } from '@hotjar/webapp/domains/activity-feed/api';
import type { ActivityFeedEvent } from '@hotjar/webapp/domains/activity-feed/types';

const CACHE_TIME = 60 * 1000; // 1 min

export const ACTIVITY_FEED_QUERY_KEY = 'activityFeed';

export const useActivityFeed = (): UseQueryResult<ActivityFeedEvent[], Error> => {
  const siteId = useCurrentSiteId();

  return useQuery([ACTIVITY_FEED_QUERY_KEY, { siteId }], () => getActivityFeed(Number(siteId)), {
    retry: false,
    enabled: !!siteId,
    cacheTime: CACHE_TIME,
    refetchOnWindowFocus: false,
  });
};
